import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

export const KpiErrorState = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col items-center justify-center py-4">
      <span
        role="alert"
        className="font-inter text-center text-sm font-medium leading-5 text-gray-750"
      >
        {t('analytics.error-screen-message')}
      </span>
    </div>
  );
};
